import * as React from "react";
import {
  ActivityFragment,
  CampaignMinimalFragment,
  UserMinimalFragment,
} from "../../../graphql/fragments";
import useTranslations from "../../../hooks/useTranslations";
import { Link } from "../../wombat-ui";
import Avatar from "../../wombat-ui/Avatar";
import { Span } from "../../wombat-ui/components/Typography";
import Activity from "../ActivityPlate";

type UserDocumentAddedActivity = ActivityFragment & {
  recipient: CampaignMinimalFragment;
  trackable: UserMinimalFragment;
};

export function isUserDocumentAddedActivity(
  q: ActivityFragment
): q is UserDocumentAddedActivity {
  return q.key === "user.document_added";
}

interface UserDocumentAddedActivityProps {
  activity: UserDocumentAddedActivity;
}

export const UserDocumentAddedActivity: React.FC<UserDocumentAddedActivityProps> = ({
  activity,
}) => {
  const t = useTranslations();

  return (
    <Activity
      activity={activity}
      id="userDocumentAddedActivity"
      visual={
        <Avatar
          src={activity.trackable.avatar}
          alt={`${activity.trackable.name} avatar`}
          type="user"
          size={10}
        />
      }
    >
      <Span className="text-sm">
        {t("activity.labels.userDocumentAdded", {
          user: (
            <Link to={`/users/${activity.trackable.slug}`} key={activity.id}>
              {activity.trackable.name}
            </Link>
          ),
        })}
      </Span>
    </Activity>
  );
};
